'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002e$002dTwo$002dFactor$002dAuth$002dView$0024$002dImported from "./presto.-Two-Factor-Auth-View$-Imported.js";
var $p;
/** @constructor */
function $c_Lpresto_Freemium2FAAddView$$anon$18(failed$3) {
  this.X8 = null;
  this.X8 = failed$3;
}
export { $c_Lpresto_Freemium2FAAddView$$anon$18 as $c_Lpresto_Freemium2FAAddView$$anon$18 };
$p = $c_Lpresto_Freemium2FAAddView$$anon$18.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_sr_AbstractPartialFunction();
$p.constructor = $c_Lpresto_Freemium2FAAddView$$anon$18;
/** @constructor */
function $h_Lpresto_Freemium2FAAddView$$anon$18() {
}
export { $h_Lpresto_Freemium2FAAddView$$anon$18 as $h_Lpresto_Freemium2FAAddView$$anon$18 };
$h_Lpresto_Freemium2FAAddView$$anon$18.prototype = $p;
$p.adI = (function(x) {
  return (this.X8.aE(x.hX) || (!x.iv.k()));
});
$p.abK = (function(x, default$1) {
  if (this.X8.aE(x.hX)) {
    var error$1 = this.X8.bu(x.hX);
    return new $j_presto$002e$002dTwo$002dFactor$002dAuth$002dView$0024$002dImported.$c_Lpresto_TwoFactorAuthView$Imported(x.hX, x.tM, x.on, x.iv, error$1);
  } else {
    return ((!x.iv.k()) ? x : default$1.w(x));
  }
});
$p.cb = (function(x) {
  return this.adI(x);
});
$p.bk = (function(x, default$1) {
  return this.abK(x, default$1);
});
var $d_Lpresto_Freemium2FAAddView$$anon$18 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_Freemium2FAAddView$$anon$18, "presto.Freemium2FAAddView$$anon$18", ({
  Jj: 1,
  a4: 1,
  t: 1,
  A: 1,
  a: 1
}));
export { $d_Lpresto_Freemium2FAAddView$$anon$18 as $d_Lpresto_Freemium2FAAddView$$anon$18 };
//# sourceMappingURL=presto.-Freemium2-F-A-Add-View$$anon$18.js.map
